import * as React from 'react';
import { htmlDecode } from '../helpers/functions';
import cx from 'classnames';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

import styles from './TestimonialSlider.module.scss';

export function TestimonialSlider(props) {
  const slides = JSON.parse(htmlDecode(props.slides));
  const { backgroundImage, title } = props;

  const settings = {
    slidesToShow: 1,
    arrows: false,
    autoplay: true,
    dots: true,
    appendDots: (dots) => (
      <div>
        <ul className="flex justify-center mt-12 list-none"> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div className="w-2 h-2 rounded-full border border-primary mx-1 hover:bg-primary cursor-pointer">
        {console.log(i)}
      </div>
    ),
  };
  return (
    <section
      className="bg-cover bg-no-repeat py-24 mb-24 px-4 lg:px-0"
      style={{
        backgroundImage: backgroundImage.hasOwnProperty('url')
          ? `url(${backgroundImage.url})`
          : `none`,
      }}
    >
      <div className="container">
        {title && (
          <div
            className={(`mb-12`, styles.title)}
            dangerouslySetInnerHTML={{ __html: htmlDecode(title) }}
          />
        )}
        <Slider {...settings} className={cx(styles.slider)}>
          {slides.map((slide, key) => (
            <div key={key} className="text-white">
              <blockquote>
                <div
                  className="font-bold text-center"
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(slide.text),
                  }}
                />
                <figcaption
                  className="text-center italic mt-4"
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(slide.name),
                  }}
                />
              </blockquote>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

const swipeConfidenceThreshold = 100;
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};
